
import { API_ERROR_CODE, DEVICE_CONFIRM_CODE, AUTH_CODE } from './dataCenter'

export function getMessge(code: any) {
    var msg: string = "errorMsg.api.api_server_failed";
    switch (code) {
        /*
        API ERROR MESSAGE
        */
        case API_ERROR_CODE.INTERNAL_SERVER_ERROR:
        case API_ERROR_CODE.DB_API_ERROR:
            msg = "errorMsg.api.api_server_failed";
            break;
        case API_ERROR_CODE.DATA_IS_NULL:
        case API_ERROR_CODE.DATA_IS_INVALID:
        case API_ERROR_CODE.DATA_HAVE_NO_REQUIRED:
        case API_ERROR_CODE.DATA_HAVE_EXCLUSIVE:
            msg = "errorMsg.api.api_invalid_data_failed";
            break;
        case API_ERROR_CODE.PERMISSION_INVALID:
        case API_ERROR_CODE.PERMISSION_CANNOT_MATCH_PLACE:
            msg = "errorMsg.api.api_permission_failed";
            break;
        case API_ERROR_CODE.PERMISSION_NOT_MASTER:
            msg = "errorMsg.api.api_master_poermission_failed";
            break;
        case API_ERROR_CODE.DEVICE_CANNOT_COM:
            msg = "errorMsg.api.api_device_cannot_com";
            break;
        case API_ERROR_CODE.DEVICE_NOT_CONNECTED:
            msg = "errorMsg.api.api_device_not_connected";
            break;
        case API_ERROR_CODE.DEVICE_ACTION_TIMEOUT:
            msg = "errorMsg.api.api_device_action_timeout";
            break;
        case API_ERROR_CODE.DEVICE_CONTROL_ERROR:
            msg = "errorMsg.api.api_device_control_error";
            break;

        /*
        DEVICE CONFIRM ERROR MESSAGE
        */
        case DEVICE_CONFIRM_CODE.DEVICE_NOT_MATCHING:
            msg = "errorMsg.device.device_not_matching";
            break;
        case DEVICE_CONFIRM_CODE.DEVICE_BUSY:
            msg = "errorMsg.device.device_busy";
            break;
        case DEVICE_CONFIRM_CODE.DEVICE_NOT_INITIAL:
            msg = "errorMsg.device.device_not_initial";
            break;
        case DEVICE_CONFIRM_CODE.DEVICE_SAME_DIRECTION:
            msg = "errorMsg.device.device_same_direction";
            break;
        case DEVICE_CONFIRM_CODE.DEVICE_NOT_FOUND:
            msg = "errorMsg.device.device_not_found";
            break;
        case DEVICE_CONFIRM_CODE.DEVICE_EXCEED_TIMER_NUM:
            msg = "errorMsg.device.device_exeed_timer_num";
            break;

        /*
        AUTH
        */
        case AUTH_CODE.AUTH_NOT_AUTHORIZATION:
            msg = "errorMsg.auth.auth_not_authorization";
            break;

        default:
            break;
    }
    return msg
}